import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import LoaderSpiner from "../../../../components/loaderSpiner";
import Dropdown from "../../../../components/Dropdown";
import { useLazyGetTagsQuery, useAddTagMutation, useUpdateTagMutation, useDeleteTagMutation } from "../../../../services/Api";
import { toast } from "react-toastify";
const TagPage = () => {
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
    const [dropdownActive, setDropdownActive] = useState(null);
    const [trigger, { data, isLoading: loading, error }] = useLazyGetTagsQuery();
    const [addTag, { isLoading: addLoading }] = useAddTagMutation()
    const [updateTag, { isLoading: updateLoading }] = useUpdateTagMutation()
    const [deleteTag, { isLoading: deleteLoading }] = useDeleteTagMutation()
    useEffect(() => {
        trigger()
    }, [])
    console.log("selected item", selectedItem)
    const closeUpdatePopup = () => {
        setIsUpdateModalOpen(false);
        setSelectedItem(null);
    };
    const closeDeletePopup = () => {
        setIsDeleteModalOpen(false);
        setSelectedDeleteItem(null);
        setDropdownActive(null);
    };
    const [formData, setFormData] = useState({
        name: selectedItem?.name || "",

    });
    useEffect(() => {
        setFormData({
            name: selectedItem?.name || "",
        });
    }, [selectedItem]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedItem != null) {
            updateTag({ data: formData, id: selectedItem?._id })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        trigger()
                        toast.success("Tag updated Successfully");
                        setFormData({
                            name: ''
                        })
                    } else {
                        toast.error(payload?.message);
                    }
                    closeUpdatePopup();
                })
                .catch((error) => {
                    toast.error(error?.data?.message);
                });
        } else {
            addTag({ data: formData })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        trigger()
                        toast.success("Tag Added Successfully");
                        setFormData({
                            name: ''
                        })
                    } else {
                        toast.error(payload?.message);
                    }
                    closeUpdatePopup();
                })
                .catch((error) => {
                    toast.error(error?.data?.message);
                });
        }


    };
    const handleDelete = () => {

        if (selectedDeleteItem != null) {
            deleteTag({ id: selectedDeleteItem?._id })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        trigger()
                        toast.success("Tag removed Successfully");
                        setFormData({
                            name: ''
                        })
                    } else {
                        toast.error(payload?.message);
                    }
                    closeDeletePopup();
                })
                .catch((error) => {
                    toast.error(error?.data?.message);
                });
        } else {

            toast.error('Select the Tag to Delete');

        }


    };
    const toggleDropdown = (index) => {
        setDropdownActive((prev) => (prev === index ? null : index));
    };
    const openUpdatePopup = (item) => {
        setIsUpdateModalOpen(true);
        setSelectedItem(item);
        setDropdownActive('');
    };
    const openDeletePopup = (item) => {
        setIsDeleteModalOpen(true);
        setSelectedDeleteItem(item);
        setDropdownActive(null);
    };

    return (
        <>
            <div className="sm:px-8 px-6 pb-5">
                <div className="flex justify-between items-center gap-4">
                    <h1 className="text-black font-['Roboto_Mono'] text-2xl font-bold ">All Tags</h1>
                    <div className="">
                        <button
                            className="flex items-center gap-3 bg-bgprimary rounded-lg px-5 py-2 font-quicksand text-black font-semibold text-[14px] "
                            onClick={() => setIsUpdateModalOpen(true)}
                        >
                            + Add New{" "}
                        </button>
                    </div>
                </div>
            </div>
            <div className="px-6">
                {/* Table Section */}
                <div className=" bg-white p-6 rounded-[1.75rem] shadow-md mb-4 md:mb-0 h-fit">
                    <table className="w-full table-auto border-separate border-spacing-y-4">
                        <thead>
                            <tr className="bg-tablecolor">
                                <th className="p-3 text-center align-middle w-8 rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                                    <input type="checkbox" className="rounded border-gray-300" />
                                </th>
                                <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
                                    ID
                                </th>
                                <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
                                    Name
                                </th>

                                <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
                                    Actions
                                </th>

                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {loading ? (
                                <></>
                            ) : (
                                data?.data?.map((items, index) => (
                                    <tr
                                        key={index}
                                        className="bg-white hover:bg-tablecolor rounded-xl"
                                    >
                                        <td className="p-3 text-center align-middle rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                                            <input
                                                type="checkbox"
                                                className="rounded border-normalGray"
                                            />
                                        </td>
                                        <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                                            {items?._id}
                                        </td>
                                        <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                                            {items?.name}
                                        </td>

                                        <td className="p-3 text-center align-middle rounded-r-xl border-r border-t border-b border-solid border-bordercolor">
                                            <Dropdown
                                                active={dropdownActive === index}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleDropdown(index);
                                                }}
                                                options={[
                                                    {
                                                        label: "Update",
                                                        onClick: (e) => {
                                                            e.stopPropagation();
                                                            openUpdatePopup(items);
                                                            toggleDropdown(index);
                                                        },
                                                    },
                                                    {
                                                        label: "Delete",
                                                        onClick: (e) => {
                                                            e.stopPropagation();
                                                            openDeletePopup(items);
                                                            toggleDropdown(index);
                                                        },
                                                    },

                                                ]}
                                            />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {loading && (
                        <div className="relative h-[30vh] w-full">
                            <LoaderSpiner />
                        </div>
                    )}

                </div>

            </div>


            {isUpdateModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-[20rem] shadow-lg relative">
                        <button
                            onClick={closeUpdatePopup}
                            className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
                        >
                            <IoClose />
                        </button>

                        <h2 className="text-xl font-semibold mb-4 text-center">
                            {selectedItem != null ? 'Update Tag' : 'Add Tag'}
                        </h2>

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Tag
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full border border-gray-300 rounded-md p-2"
                                />
                            </div>

                            <button type="submit" className="px-4 py-2 bg-bgprimary text-dark font-semibold font-quicksand rounded-md">
                                {selectedItem != null ? 'Update Tag' : 'Add Tag'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
            {isDeleteModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-[20rem] shadow-lg relative">
                        <button
                            onClick={closeDeletePopup}
                            className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
                        >
                            <IoClose />
                        </button>

                        <h2 className="text-xl font-semibold mb-4 text-center">
                            Are You Sure to want to delete the Tag?
                        </h2>


                        <div className="flex justify-center items-center gap-4 my-4" >
                            <button onClick={closeDeletePopup} className="px-4 py-2 bg-bgprimary text-dark font-semibold font-quicksand rounded-md">
                                Cancel
                            </button>
                            <button onClick={handleDelete} className="px-4 py-2 bg-red-700 text-white ml-2 font-semibold font-quicksand rounded-md">
                                {deleteLoading ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>

                    </div>
                </div>
            )}




        </>

    )
}

export default TagPage
